import { Link, useLocation } from "react-router-dom"
import { logMessage } from "../../utils/utils"

const scrollUp = () => {
  window.scrollTo({ top: 0, behavior: "smooth" })
}

const ServiceCard = ({ serv }) => {
  const handleClick = () => {
    scrollUp()
    logMessage(serv.titleUa)
  }

  const location = useLocation()
  return (
    <Link
      to={location.pathname === "/" ? `../services/${serv.link}` : serv.link}
      onClick={handleClick}
    >
      <div className="flex flex-col max-w-[299px]  rounded-lg  border-[#002898]/[.80] hover:scale-105 duration-300 cursor-pointer lg:grayscale-0 lg:hover:grayscale-0 shadow-[0px_0px_20px_5px] hover:shadow-[0px_0px_20px_10px] shadow-[#002898]/[.80] hover:shadow-[#002898]/[.80]">
        <div className="px-2 bg-mother-board-card bg-cover bg-center  h-[88px] flex items-center justify-center rounded-t">
          <h2 className=" font-semibold text-xl xs:text-xl lg:text-xl text-black hover:text-white bg-white/[.90] hover:bg-black/[.50] py-2 px-3 rounded-lg border-2 border-black hover:border-white hover:scale-[1.03] duration-200">
            {serv.titleUa}
          </h2>
        </div>
        <img
          src={serv.img}
          className=" rounded-b border-t-4 border-black max-w-[299px] h-[233px]"
        />
      </div>
    </Link>
  )
}

export default ServiceCard
